export const LOGIN_API='api/login';
export const DEMO_LOGIN_API='api/demo-user-login';
export const SEND_OTP='api/send-otp';
export const REGISTER='api/register';
export const FORGOT_PASSWORD='api/forgot-password';
export const CAPTCHA_API='api/v1/captcha';